import { render, staticRenderFns } from "./Perform.vue?vue&type=template&id=d87cfb92&scoped=true&"
import script from "./Perform.vue?vue&type=script&lang=js&"
export * from "./Perform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87cfb92",
  null
  
)

export default component.exports